export const telegramWebOrigin = "https://telegram.me";

export function telegramProfileUrl(username: string) {
  return `${telegramWebOrigin}/${username}`;
}

export function normalizeExternalLink(value: string, username?: string) {
  if (username) return telegramProfileUrl(username);

  const href = value.startsWith("http://") || value.startsWith("https://") ? value : `https://${value}`;

  try {
    const url = new URL(href);
    const hostname = url.hostname.toLowerCase().replace(/^www\./, "");
    if (hostname === "t.me" || hostname === "telegram.me") {
      return `${telegramWebOrigin}${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    // Linkification only passes URL-shaped values; keep an unexpected value usable.
  }

  return href;
}
